import { useState } from 'react'
import { MinimalAlert, MinimalButton, MinimalDropdown, MinimalInput } from '@ovasabi/ui-minimal'
import { stockOptions, type Board } from './model'

type Props = { board: Board; location: string; disabled: boolean; save: (kind: 'stock', payload: Record<string, unknown>) => Promise<boolean> }

export function Stock({ board, location, disabled, save }: Props) {
  const [message, setMessage] = useState('')
  const saved = (key: string) => board.stock.find((item) => item.location_id === location && item.item_key === key)
  return <section className="stack" aria-label="Stock check">
    <div className="small-stack"><h2>Stock check</h2><p className="muted">A quick daily check keeps dishes honest. Use the note for a supplier reminder or prep warning.</p></div>
    {message && <MinimalAlert tone="success">{message}</MinimalAlert>}
    {!board.stock_items.length && <p className="empty">Add ingredients to your dishes to create stock items.</p>}
    <div className="lines">{board.stock_items.map((item) => {
      const current = saved(item.key)
      return <StockRow key={item.key} item={item.name} value={current?.status ?? 'unknown'} note={current?.note ?? ''} disabled={disabled} onSave={async (status, note) => {
        const ok = await save('stock', { location_id: location, item_key: item.key, status, note, expected_revision: current?.revision ?? 0 })
        if (ok) setMessage(`${item.name} saved`)
      }} />
    })}</div>
  </section>
}

function StockRow({ item, value, note, disabled, onSave }: { item: string; value: string; note: string; disabled: boolean; onSave: (status: string, note: string) => Promise<void> }) {
  const [status, setStatus] = useState(value)
  const [text, setText] = useState(note)
  return <article className="line stock-grid">
    <div className="small-stack"><h3>{item}</h3><p className="muted">Stock is tracked separately for each kitchen location.</p><MinimalInput label="Note (optional)" maxLength={240} value={text} disabled={disabled} onChange={(event) => setText(event.target.value)} /></div>
    <div className="small-stack"><MinimalDropdown label="Stock status" options={stockOptions.map((option) => ({ value: option.value, label: option.label }))} value={status} disabled={disabled} onChange={setStatus} /><MinimalButton disabled={disabled} onClick={() => void onSave(status, text)}>Save check</MinimalButton></div>
  </article>
}
